import { render } from "./BottomToolComp.vue?vue&type=template&id=74616606&scoped=true"
import script from "./BottomToolComp.vue?vue&type=script&lang=js"
export * from "./BottomToolComp.vue?vue&type=script&lang=js"

import "./BottomToolComp.vue?vue&type=style&index=0&id=74616606&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74616606"]])

export default __exports__